import { sendCommand } from '../core/command.js';

function errorNotification(name, message) {
    return sendCommand({
        command: 'action',
        params: {
            hasHeader: true,
            header: name,
            message,
        },
    });
}

export { errorNotification };
//# sourceMappingURL=errorNorification.js.map
